var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoWish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_3791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0811 5.586L0.900123 18.769C0.358542 19.3497 0.0635648 20.118 0.0773596 20.912C0.0911544 21.7059 0.412644 22.4635 0.974072 23.0251C1.5355 23.5866 2.29301 23.9083 3.08696 23.9223C3.88091 23.9362 4.64928 23.6415 5.23012 23.1L18.4141 9.919L14.0811 5.586ZM15.5861 9.919L13.0001 12.505L11.5001 11L14.0861 8.414L15.5861 9.919ZM3.81612 21.688C3.61397 21.8807 3.3454 21.9882 3.06612 21.9882C2.78684 21.9882 2.51828 21.8807 2.31612 21.688C2.11754 21.4889 2.00602 21.2192 2.00602 20.938C2.00602 20.6568 2.11754 20.3871 2.31612 20.188L10.0851 12.418L11.5901 13.923L3.81612 21.688ZM21.3331 14.628L24.0001 15.962L21.3331 17.3L20.0001 19.962L18.6671 17.3L16.0001 15.962L18.6671 14.628L20.0001 11.962L21.3331 14.628ZM6.66712 5.333L4.00012 4L6.66712 2.667L8.00012 0L9.33312 2.667L12.0001 4L9.33312 5.333L8.00012 8L6.66712 5.333ZM19.3331 4.667L17.0001 3.5L19.3331 2.333L20.5001 0L21.6671 2.333L24.0001 3.5L21.6671 4.667L20.5001 7L19.3331 4.667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_3791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWish);
export default __webpack_public_path__ + "static/media/ico_wish.d4805f630282354568156afc9636627a.svg";
export { ForwardRef as ReactComponent };